<div class="row">
	<div class="col-12">
		<div class="content-header">Project Audit</div>
	</div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
	<div class="row">
		<div class="col-12">
			<div class="card">

				<div class="card-content"> 
					<div class="card-body">
						<div class="row">
							<div class="col-md">
								<form>
									<fieldset class="form-group">
										<label for="projectbudget">Communication</label>
										<input type="text" class="form-control" [(ngModel)]="jobModel.Communication"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter Communication">
									</fieldset>
									<fieldset class="form-group">
										<label for="projectbudget">Sprints</label>
										<input type="text" class="form-control" [(ngModel)]="jobModel.sprints"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter sprints">
									</fieldset>
									<fieldset class="form-group">
										<label for="projectbudget">Mom</label>
										<input type="text" class="form-control" [(ngModel)]="jobModel.mom"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter mom">
									</fieldset>
									<fieldset class="form-group">
										<label for="projectbudget">FRS/DMS</label>
										<input type="text" class="form-control" [(ngModel)]="jobModel.dmsfrs"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter dmsfrs">
									</fieldset>
									<fieldset class="form-group">
										<label for="projectbudget">KPI</label>
										<input type="text" class="form-control" [(ngModel)]="jobModel.kpi"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter kpi">
									</fieldset>
									<fieldset class="form-group">
										<label for="projectbudget">Reports</label>
										<input type="text" class="form-control" [(ngModel)]="jobModel.reports"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter reports">
									</fieldset>
								</form>
							</div>
							<div class="col-md">
								<form >
									<fieldset class="form-group">
										<label for="projectbudget">Work Dairy</label> 
										<input type="text" class="form-control" [(ngModel)]="jobModel.workdairy"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter work dairy">
									</fieldset>
									<fieldset class="form-group">
										<label for="projectbudget">Bit Bucket</label>
										<input type="text" class="form-control" [(ngModel)]="jobModel.bitbucket"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter bit bucket">
									</fieldset>
									<fieldset class="form-group">
										<label for="projectbudget">Demo</label>
										<input type="text" class="form-control"  [(ngModel)]="jobModel.demo"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter demo">
									</fieldset>
									<fieldset class="form-group">
										<label for="projectbudget">QA</label>
										<input type="text" class="form-control" [(ngModel)]="jobModel.qa"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter qa">
									</fieldset>
									<fieldset class="form-group">
										<label for="projectbudget">Crequest</label>
										<input type="text" class="form-control"  [(ngModel)]="jobModel.crequest"  [ngModelOptions]="{standalone: true}"
										placeholder="Enter crequest">
									</fieldset>
									<fieldset>
										<label for="notes">Alert<span class="required_field">*</span></label>
										<ng-select
											[items]="alert_list"
											bindLabel="name"
											color="is_activated"
											bindValue="id"
											placeholder="Select Alert"
											[(ngModel)]="alert_event"
											[ngModelOptions]="{ standalone: true }"
											(change)="selectAlert($event)" 
										>
										</ng-select>
									</fieldset>
									
								</form>
							</div>
						</div>
						<div class="row">
							<!-- <div class="col-12">
								<form [formGroup]="jobsForm">
									<fieldset class="form-group">
										<label for="notes">Alert Notes</label>
										<textarea formControlName="alert_notes" [(ngModel)]="jobModel.alert_notes"
											id="hidden-label-form-6" rows="3" class="form-control " name="comment2"
											placeholder="Enter alert notes">
										</textarea>
									</fieldset>
									<fieldset class="form-group">
										<label for="notes">Process Notes</label>
										<textarea formControlName="notes" [(ngModel)]="jobModel.notes"
											id="hidden-label-form-6" rows="3" class="form-control " name="comment2"
											placeholder="Enter process notes" required #notes></textarea>
									</fieldset>
									<fieldset class="form-group">
										<label for="admin_notes">Credentials & Admin Notes</label>
										<textarea formControlName="admin_notes" [(ngModel)]="jobModel.admin_notes"
											id="hidden-label-form-6" rows="3" class="form-control " name="comment2"
											placeholder="Enter credentials & admin notes">
										</textarea>
									</fieldset>
								</form>
							</div> -->
							<div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
								<button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
									(click)="updateJob()">Submit</button>
								<button type="reset" class="btn btn-secondary" (click)="back()">Cancel</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
